import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, MapPin, Phone, Navigation, BookOpen, ChevronDown, GraduationCap, Share2 } from "lucide-react";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";

export default function Schools() {
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  };

  // 🔥 94 Schools of Kalliasseri Constituency 🔥
  const schoolsData = [
    { id: 1, name: "GBHSS CHERUKUNNU", place: "Cherukunnu", type: "Government", classes: "Class 5 - 12", phone: "0497-2861188" },
    { id: 2, name: "GVHSS CHERUKUNNU", place: "Cherukunnu", type: "Government", classes: "Class 5 - 12", phone: "0497-2861793" },
    { id: 3, name: "CHMKSGHSS MATTUL", place: "Mattool", type: "Government", classes: "Class 8 - 12", phone: "0497-2843085" },
    { id: 4, name: "NAJATH GIRLS HS MATTUL", place: "Mattool", type: "Private/Unaided", classes: "Class 1 - 12", phone: "7994258314" },
    { id: 5, name: "GBVHSS MADAYI", place: "Madayi", type: "Government", classes: "Class 5 - 12", phone: "0497-2870757" },
    { id: 6, name: "GHSS KOTTILA", place: "Kottila", type: "Government", classes: "Class 1 - 12", phone: "0497-2815024" },
    { id: 7, name: "GHSS CHERUTHAZHAM", place: "Cheruthazham", type: "Government", classes: "Class 1 - 12", phone: "0497-2802100" },
    { id: 8, name: "GGHSS MADAYI", place: "Madayi", type: "Government", classes: "Class 5 - 12", phone: "0497-2873560" },
    { id: 9, name: "JAMA-ATH HS PUTHIYANGADI", place: "Puthiyangadi", type: "Aided", classes: "Class 8 - 12", phone: "0497-2871056" },
    { id: 10, name: "GHSS KUNHIMANGALAM", place: "Kunhimangalam", type: "Government", classes: "Class 8 - 12", phone: "0497-2810364" },
    { id: 11, name: "GHSS KADANNAPPALLY", place: "Kadannappally", type: "Government", classes: "Class 8 - 12", phone: "0498-5277157" },
    { id: 12, name: "GWHSS CHERUKUNNU", place: "Cherukunnu", type: "Government", classes: "Class 1 - 12", phone: "0497-2861985" },
    { id: 13, name: "WADIHUDA HS PAYANGADI", place: "Payangadi", type: "Private/Unaided", classes: "Class 1 - 12", phone: "0497-2877577" },
    { id: 14, name: "RAHMANIYA HS MUTTAM", place: "Muttam", type: "Private/Unaided", classes: "Class 1 - 10", phone: "0497-2877518" },
    { id: 15, name: "TECHNICAL HS NERUVAMBRAM", place: "Neruvambram", type: "Government", classes: "Class 8 - 12", phone: "0497-2871789" },
    { id: 16, name: "CENTRAL MUSLIM LPS MATTUL", place: "Mattool", type: "Aided", classes: "Class 1 - 4", phone: "0497-2842705" },
    { id: 17, name: "CHERUKKUNNU MUSLIM LPS", place: "Cherukunnu", type: "Aided", classes: "Class 1 - 4", phone: "8075023511" },
    { id: 18, name: "SANKARAVILASAM A.L.P.S", place: "Mandoor", type: "Aided", classes: "Class 1 - 4", phone: "0497-2802765" },
    { id: 19, name: "CHRIST NAGAR LPS EDAKOME", place: "Edakome", type: "Aided", classes: "Class 1 - 4", phone: "0460-2271833" },
    { id: 20, name: "EDAKKEPPURAM LPS", place: "Edakkeppuram", type: "Aided", classes: "Class 1 - 4", phone: "0497-2863119" },
    { id: 21, name: "EDANAD EAST LPS", place: "Edanad", type: "Aided", classes: "Class 1 - 4", phone: "0497-2805366" },
    { id: 22, name: "EDANAD WEST LPS", place: "Edanad", type: "Aided", classes: "Class 1 - 4", phone: "9847575973" },
    { id: 23, name: "EZHOME HINDU LPS", place: "Ezhome", type: "Aided", classes: "Class 1 - 4", phone: "0497-2873755" },
    { id: 24, name: "GLPS CHERUKKUNNU NORTH", place: "Cherukunnu", type: "Government", classes: "Class 1 - 4", phone: "0497-2860875" },
    { id: 25, name: "GLPS CHERUKUNNU SOUTH", place: "Cherukunnu", type: "Government", classes: "Class 1 - 4", phone: "0497-2860540" },
    { id: 26, name: "GLPS CHERUTHAZHAM SOUTH", place: "Cheruthazham", type: "Government", classes: "Class 1 - 4", phone: "0497-2870685" },
    { id: 27, name: "GLPS CHERUVACHERRY", place: "Cheruvacherry", type: "Government", classes: "Class 1 - 4", phone: "0498-5278613" },
    { id: 28, name: "GLPS KARAYAD", place: "Karayad", type: "Government", classes: "Class 1 - 4", phone: "0498-5270960" },
    { id: 29, name: "GLPS KUNHIMANGALAM", place: "Kunhimangalam", type: "Government", classes: "Class 1 - 4", phone: "0497-2810288" },
    { id: 30, name: "GLPS PANAPPUZHA", place: "Panappuzha", type: "Government", classes: "Class 1 - 4", phone: "0498-5270680" },
    { id: 31, name: "GLPS THEKKEKKARA", place: "Thekkekkara", type: "Government", classes: "Class 1 - 4", phone: "0497-2801142" },
    { id: 32, name: "GMLPS KUNHIMANGALAM", place: "Kunhimangalam", type: "Government", classes: "Class 1 - 4", phone: "0497-2810066" },
    { id: 33, name: "GMLPS MADAKKARA", place: "Madakkara", type: "Government", classes: "Class 1 - 5", phone: "0497-2868037" },
    { id: 34, name: "GMLPS MATTUL", place: "Mattool", type: "Government", classes: "Class 1 - 4", phone: "0497-2842795" },
    { id: 35, name: "GMLPS NARIKODE", place: "Narikode", type: "Government", classes: "Class 1 - 4", phone: "0497-2816722" },
    { id: 36, name: "GWLPS EZHOME", place: "Ezhome", type: "Government", classes: "Class 1 - 4", phone: "0497-2872177" },
    { id: 37, name: "GWLPS MADAKKARA", place: "Madakkara", type: "Government", classes: "Class 1 - 4", phone: "0497-2867280" },
    { id: 38, name: "IRINAVU THEKKUMBAD ALPS", place: "Thekkumbad", type: "Aided", classes: "Class 1 - 4", phone: "8921164064" },
    { id: 39, name: "KANNOM LPS", place: "Kannom", type: "Aided", classes: "Class 1 - 4", phone: "0497-2816710" },
    { id: 40, name: "MADAYI LPS", place: "Madayi", type: "Aided", classes: "Class 1 - 4", phone: "0497-2871621" },
    { id: 41, name: "MADAYIKKAVU LPS", place: "Chengal", type: "Aided", classes: "Class 1 - 4", phone: "0497-2872185" },
    { id: 42, name: "MATTUL ALPS", place: "Mattool", type: "Aided", classes: "Class 1 - 4", phone: "0497-2841210" },
    { id: 43, name: "DEVIVILASAM LPS THAVAM", place: "Thavam", type: "Aided", classes: "Class 1 - 5", phone: "9744007670" },
    { id: 44, name: "MUTTIL LPS", place: "Muttil", type: "Aided", classes: "Class 1 - 4", phone: "0497-2871949" },
    { id: 45, name: "ONAPPARAMBA LPS", place: "Onapparamba", type: "Aided", classes: "Class 1 - 4", phone: "0497-2816123" },
    { id: 46, name: "PUTHIYANGADI WEST LPS", place: "Puthiyangadi", type: "Aided", classes: "Class 1 - 4", phone: "0497-2872405" },
    { id: 47, name: "SRVLPS CHERUTHAZHAM", place: "Cheruthazham", type: "Aided", classes: "Class 1 - 4", phone: "9495610589" },
    { id: 48, name: "SREE VAYALAPRA APBKD LPS", place: "Vayalapra", type: "Aided", classes: "Class 1 - 4", phone: "7907466924" },
    { id: 49, name: "ST. MARYS LPS VILAYANKODE", place: "Vilayankode", type: "Aided", classes: "Class 1 - 4", phone: "0497-2801024" },
    { id: 50, name: "ST. MARYS LPS PUNNACHERI", place: "Punnacheri", type: "Aided", classes: "Class 1 - 4", phone: "0497-2860780" },
    { id: 51, name: "VARANAKODE LPS", place: "Varanakode", type: "Aided", classes: "Class 1 - 4", phone: "0497-2871670" },
    { id: 52, name: "VDNM GWLPS EZHILODE", place: "Ezhilode", type: "Government", classes: "Class 1 - 4", phone: "0497-2800922" },
    { id: 53, name: "VMLPS ARATHIL", place: "Arathil", type: "Aided", classes: "Class 1 - 4", phone: "9400612607" },
    { id: 54, name: "ERIPURAM CHENGAL LPS", place: "Eripuram", type: "Aided", classes: "Class 1 - 5", phone: "9495325279" },
    { id: 55, name: "KADANNAPPALLY EAST LPS", place: "Kadannappally", type: "Aided", classes: "Class 1 - 5", phone: "0498-5278690" },
    { id: 56, name: "KANNAPURAM NORTH LPS", place: "Kannapuram", type: "Aided", classes: "Class 1 - 5", phone: "0497-2861115" },
    { id: 57, name: "MADAYI SOUTH LPS", place: "Madayi", type: "Aided", classes: "Class 1 - 5", phone: "9633263194" },
    { id: 58, name: "MIMLPS MATTUL", place: "Mattool", type: "Aided", classes: "Class 1 - 5", phone: "9895476710" },
    { id: 59, name: "PARUR ALPS", place: "Parur", type: "Aided", classes: "Class 1 - 5", phone: "9946459138" },
    { id: 60, name: "MATTUL DEVI VILASAM LPS", place: "Mattool", type: "Aided", classes: "Class 1 - 4", phone: "0497-2841212" },
    { id: 61, name: "VENGARA HINDU LPS", place: "Vengara", type: "Aided", classes: "Class 1 - 5", phone: "0497-2877675" },
    { id: 62, name: "GMUPS MADAYI", place: "Madayi", type: "Government", classes: "Class 1 - 7", phone: "0497-2873387" },
    { id: 63, name: "GMUPS PAYANGADI", place: "Payangadi", type: "Government", classes: "Class 1 - 7", phone: "0497-2877522" },
    { id: 64, name: "GWUPS VENGARA", place: "Vengara", type: "Government", classes: "Class 1 - 7", phone: "0497-2870070" },
    { id: 65, name: "VENGARA MAPPILA UPS", place: "Vengara", type: "Aided", classes: "Class 1 - 7", phone: "0497-2873825" },
    { id: 66, name: "KANNAPURAM EAST UPS", place: "Kannapuram", type: "Aided", classes: "Class 1 - 7", phone: "0497-2862142" },
    { id: 67, name: "ODAYAMMADAM UPS", place: "Odayammadam", type: "Aided", classes: "Class 1 - 7", phone: "0497-2863597" },
    { id: 68, name: "GMUPS THEKKUMBAD", place: "Thekkumbad", type: "Government", classes: "Class 1 - 7", phone: "0497-2860920" },
    { id: 69, name: "MRUPS MATTUL", place: "Mattool", type: "Aided", classes: "Class 1 - 7", phone: "0497-2844725" },
    { id: 70, name: "MUPS MATTUL", place: "Mattool", type: "Aided", classes: "Class 1 - 7", phone: "0497-2844205" },
    { id: 71, name: "N M U P S MATTUL", place: "Mattool", type: "Aided", classes: "Class 1 - 7", phone: "0497-2844255" },
    { id: 72, name: "LFUPS MATTUL", place: "Mattool", type: "Aided", classes: "Class 1 - 7", phone: "9497485308" },
    { id: 73, name: "GNUPS NARIKKODE", place: "Narikkode", type: "Government", classes: "Class 1 - 7", phone: "9447086655" },
    { id: 74, name: "GMUPS EZHOME", place: "Ezhome", type: "Government", classes: "Class 1 - 7", phone: "0497-2873123" },
    { id: 75, name: "GUPS PURACHERY", place: "Purachery", type: "Government", classes: "Class 1 - 7", phone: "0497-2080563" },
    { id: 76, name: "GCUPS KUNHIMANGALAM", place: "Kunhimangalam", type: "Government", classes: "Class 1 - 7", phone: "0497-2811222" },
    { id: 77, name: "GOPAL UPS KUNHIMANGALAM", place: "Kunhimangalam", type: "Aided", classes: "Class 1 - 7", phone: "Not Available" },
    { id: 78, name: "KADANNAPPALLY UPS", place: "Kadannappally", type: "Aided", classes: "Class 1 - 7", phone: "0497-2800873" },
    { id: 79, name: "EDAMANA UPS", place: "Edamana", type: "Aided", classes: "Class 1 - 7", phone: "0498-52294260" },
    { id: 80, name: "ERIAM VIDYAMITHRAM UPS", place: "Eriam", type: "Aided", classes: "Class 1 - 7", phone: "0460-2280547" },
    { id: 81, name: "VENGARA PRIYADARSHINI UPS", place: "Vengara", type: "Aided", classes: "Class 5 - 7", phone: "0497-2875796" },
    { id: 82, name: "EDAKKEPPURAM UPS", place: "Edakkeppuram", type: "Aided", classes: "Class 5 - 7", phone: "0497-2863124" },
    { id: 83, name: "NERUVAMBRAM U P S", place: "Neruvambram", type: "Aided", classes: "Class 5 - 7", phone: "0497-2873800" },
    { id: 84, name: "PILATHARA UPS", place: "Pilathara", type: "Aided", classes: "Class 5 - 7", phone: "0497-2800410" },
    { id: 85, name: "EDANAD UPS", place: "Edanad", type: "Aided", classes: "Class 5 - 7", phone: "0497-2805003" },
    { id: 86, name: "AMIM UPS KOYAPPARA", place: "Koyappara", type: "Private/Unaided", classes: "Class 5 - 7", phone: "Not Available" },
    { id: 87, name: "MECA PAZHAYANGADI", place: "Payangadi", type: "Private/Unaided", classes: "Class 1 - 10", phone: "0497-2870960" },
    { id: 88, name: "BAKHITHA ENGLISH MEDIUM HS", place: "Cherukunnu", type: "Private/Unaided", classes: "Class 1 - 10", phone: "0497-2862833" },
    { id: 89, name: "A D L P S PALLIKKARA", place: "Pallikkara", type: "Aided", classes: "Class 1 - 4", phone: "0497-2874799" },
    { id: 90, name: "B E M L P S MADAYI", place: "Madayi", type: "Aided", classes: "Class 1 - 4", phone: "9048150953" },
    { id: 91, name: "ATHIYADAM L P S", place: "Athiyadam", type: "Aided", classes: "Class 1 - 4", phone: "9605760414" },
    { id: 92, name: "BRIGHT ENGLISH SCHOOL", place: "Cherukunnu", type: "Private/Unaided", classes: "Class 1 - 7", phone: "0497-2861684" },
    { id: 93, name: "MEDICAL COLLEGE PUBLIC SCHOOL", place: "Pariyaram", type: "Government", classes: "Class 1 - 10", phone: "0497-2808840" },
    { id: 94, name: "KARUNYANIKETHAN FOR THE DEAF", place: "Vilayankode", type: "Aided", classes: "Class 1 - 10", phone: "0497-2802080" }
  ];

  const filteredSchools = schoolsData.filter((school) => {
    const matchSearch = school.name.toLowerCase().includes(search.toLowerCase()) || 
                        school.place.toLowerCase().includes(search.toLowerCase());
    const matchType = typeFilter === "All" || school.type === typeFilter;
    
    return matchSearch && matchType;
  });

  // 🔥 Page Share Functionality 🔥
  const handlePageShare = async () => {
    const shareData = {
      title: "Schools in Kalliasseri | Info Payangadi",
      text: "കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ സ്കൂളുകളുടെ പൂർണ്ണ വിവരങ്ങൾ ഒറ്റ ക്ലിക്കിൽ അറിയാൻ ഈ ലിങ്ക് സന്ദർശിക്കുക.",
      url: "https://info.payangadilive.com/schools" 
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      navigator.clipboard.writeText(shareData.url);
      toast.success("ലിങ്ക് കോപ്പി ചെയ്തിട്ടുണ്ട്! (Link Copied)");
    }
  };

  // 🔥 Individual Item Share 🔥
  const handleShare = async (school) => {
    const shareData = {
      title: `${school.name} | Info Payangadi`,
      text: `🏫 *${school.name}*\n📍 ${school.place}\n📚 ${school.classes}\n🔖 ${school.type}\n📞 ${school.phone && school.phone !== "Not Available" ? school.phone : "No Phone Available"}\n\nFor more details, visit Info Payangadi.`,
      url: "https://info.payangadilive.com/schools"
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      navigator.clipboard.writeText(shareData.text);
      toast.success("വിവരങ്ങൾ കോപ്പി ചെയ്തിട്ടുണ്ട്! (Copied)");
    }
  };

  // Helper to generate Google Maps link based on School Name and Place
  const getMapLink = (name, place) => {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(name + " " + place)}`;
  };

  return (
    <>
      {/* 🔥 Full SEO Tags 🔥 */}
      <Helmet>
        <title>Schools & Institutions | Info Payangadi</title>
        <meta name="description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ സർക്കാർ, എയ്ഡഡ്, അൺ-എയ്ഡഡ് വിദ്യാലയങ്ങളുടെ പൂർണ്ണ വിവരങ്ങൾ." />
        <meta name="keywords" content="Schools Payangadi, Kalliasseri Schools, GHSS Madayi, Cherukunnu, Kannur Education, Info Payangadi" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://info.payangadilive.com/schools" />
        <meta property="og:title" content="Schools & Institutions | Info Payangadi" />
        <meta property="og:description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ സർക്കാർ, എയ്ഡഡ് വിദ്യാലയങ്ങളുടെ പൂർണ്ണ വിവരങ്ങൾ ഒറ്റ ക്ലിക്കിൽ." />
        <meta property="og:image" content="https://info.payangadilive.com/Infopayangadi.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Schools & Institutions | Info Payangadi" />
        <meta name="twitter:description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ വിദ്യാലയങ്ങളുടെ ഡയറക്ടറി." />
        <meta name="twitter:image" content="https://info.payangadilive.com/Infopayangadi.jpg" />
      </Helmet>

      <div className="min-h-[100dvh] bg-[#F8FAFC] pb-24 selection:bg-blue-200 overflow-x-hidden relative">
        
        {/* Background Glows (Indigo & Blue Theme) */}
        <div className="absolute top-[-10%] left-[-10%] w-[350px] h-[350px] bg-indigo-400/15 rounded-full blur-[100px] pointer-events-none"></div>
        <div className="absolute top-[20%] right-[-10%] w-[350px] h-[350px] bg-blue-400/10 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-8 md:pt-12 relative z-10">
          
          {/* TITLE SECTION WITH SHARE BUTTON */}
          <div className="text-center mb-10 px-2 flex flex-col items-center">
            <div className="inline-flex items-center justify-center p-3.5 bg-white text-indigo-600 rounded-2xl mb-3 shadow-[0_8px_30px_rgb(79,70,229,0.12)] border border-indigo-50">
              <GraduationCap size={32} strokeWidth={2.5} />
            </div>
            <h2 className="text-3xl sm:text-4xl font-black text-slate-800 tracking-tight">
              Schools & <span className="text-indigo-600">Institutions</span>
            </h2>
            <p className="text-sm sm:text-base text-slate-500 mt-1 font-medium">കല്യാശ്ശേരി മണ്ഡലത്തിലെ 94 വിദ്യാലയങ്ങൾ</p>

            {/* Page Share Button */}
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={handlePageShare}
              className="mt-4 flex items-center gap-2 bg-white hover:bg-indigo-50 text-slate-600 hover:text-indigo-600 px-5 py-2.5 rounded-full shadow-sm border border-slate-200 transition-all duration-200 font-bold text-sm"
            >
              <Share2 size={16} strokeWidth={2.5} />
              Share Page
            </motion.button>
          </div>

          {/* 🔍 SEARCH + FILTER SECTION */}
          <div className="max-w-3xl mx-auto mb-10 flex flex-col md:flex-row gap-3 sm:gap-4 px-1">
            
            {/* Search Bar */}
            <div className="relative flex-1 group">
              <Search size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-500 transition-colors" strokeWidth={2.5} />
              <input
                type="text"
                placeholder="സ്കൂളോ സ്ഥലമോ തിരയുക..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-11 pr-4 py-3.5 rounded-2xl border border-slate-200 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.03)] focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-400 outline-none transition-all text-sm font-semibold text-slate-800 placeholder:text-slate-400"
              />
            </div>

            {/* Filter Dropdown */}
            <div className="relative w-full md:w-56 group">
              <select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                className="w-full appearance-none py-3.5 pl-4 pr-10 rounded-2xl border border-slate-200 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.03)] focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-400 outline-none transition-all text-sm font-bold text-slate-700 cursor-pointer"
              >
                <option value="All">All Schools</option>
                <option value="Government">Government</option>
                <option value="Aided">Aided</option>
                <option value="Private/Unaided">Private / Unaided</option>
              </select>
              <ChevronDown size={18} strokeWidth={2.5} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-500 pointer-events-none transition-colors" />
            </div>

          </div>

          {/* 🏫 SCHOOLS LIST */}
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid md:grid-cols-2 gap-4 sm:gap-6"
          >
            <AnimatePresence>
              {filteredSchools.map((school) => (
                <motion.div
                  key={school.id}
                  variants={itemVariants}
                  layout
                  className="bg-white rounded-[2rem] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 hover:shadow-[0_15px_40px_rgb(79,70,229,0.08)] transition-all duration-300 relative overflow-hidden group"
                >
                  {/* Type Badge */}
                  <div className="absolute top-5 right-5">
                    <span className={`px-3 py-1.5 rounded-full text-[10px] sm:text-xs font-black tracking-widest shadow-sm uppercase
                      ${school.type === "Government" ? "bg-green-50 text-green-600 border border-green-100" : 
                        school.type === "Aided" ? "bg-blue-50 text-blue-600 border border-blue-100" : 
                        "bg-orange-50 text-orange-600 border border-orange-100"}`}
                    >
                      {school.type}
                    </span>
                  </div>

                  {/* Info */}
                  <div className="pr-20 sm:pr-24">
                    <h3 className="text-lg sm:text-xl font-black text-slate-800 leading-tight mb-3 tracking-tight">
                      {school.name}
                    </h3>
                    
                    <div className="space-y-2 mt-2">
                      <div className="flex items-start gap-2.5 text-slate-500">
                        <div className="bg-red-50 p-1.5 rounded-lg flex-shrink-0">
                          <MapPin size={16} className="text-red-500" strokeWidth={2.5} />
                        </div>
                        <span className="text-xs sm:text-sm font-semibold mt-0.5">{school.place}</span>
                      </div>
                      
                      <div className="flex items-center gap-2.5 text-slate-500">
                        <div className="bg-indigo-50 p-1.5 rounded-lg flex-shrink-0">
                          <BookOpen size={16} className="text-indigo-500" strokeWidth={2.5} />
                        </div>
                        <span className="text-xs sm:text-sm font-bold mt-0.5">{school.classes}</span>
                      </div>

                      {school.phone && school.phone !== "Not Available" && (
                        <div className="flex items-center gap-2.5 text-slate-500">
                          <div className="bg-emerald-50 p-1.5 rounded-lg flex-shrink-0">
                            <Phone size={16} className="text-emerald-500" strokeWidth={2.5} />
                          </div>
                          <span className="text-xs sm:text-sm font-bold mt-0.5">{school.phone}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Action Buttons (Card) */}
                  <div className="mt-6 flex items-center gap-2 sm:gap-3 pt-5 border-t border-slate-100">
                    
                    <a 
                      href={school.phone && school.phone !== "Not Available" ? `tel:${school.phone}` : "#"} 
                      onClick={(e) => {
                        if (!school.phone || school.phone === "Not Available") {
                          e.preventDefault();
                          toast.error("Phone number not available");
                        }
                      }}
                      className={`flex-1 flex items-center justify-center gap-1.5 sm:gap-2 py-3 rounded-xl transition-all duration-200 font-bold text-xs sm:text-sm ${
                        school.phone && school.phone !== "Not Available" 
                          ? "bg-indigo-50 hover:bg-indigo-600 text-indigo-700 hover:text-white" 
                          : "bg-slate-50 text-slate-400 cursor-not-allowed"
                      }`}
                    >
                      <Phone size={16} strokeWidth={2.5} />
                      Call
                    </a>
                    
                    <a 
                      href={getMapLink(school.name, school.place)} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex-1 flex items-center justify-center gap-1.5 sm:gap-2 bg-blue-50 hover:bg-blue-600 text-blue-600 hover:text-white py-3 rounded-xl transition-all duration-200 font-bold text-xs sm:text-sm"
                    >
                      <Navigation size={16} strokeWidth={2.5} />
                      Map
                    </a>

                    {/* 🔥 Individual Share Button 🔥 */}
                    <button
                      onClick={() => handleShare(school)}
                      className="w-12 h-12 flex items-center justify-center bg-slate-50 hover:bg-slate-800 text-slate-600 hover:text-white rounded-xl transition-all duration-200 shrink-0"
                      aria-label="Share Details"
                    >
                      <Share2 size={18} strokeWidth={2.5} />
                    </button>

                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

          {/* No Results Found */}
          {filteredSchools.length === 0 && (
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
              className="text-center py-16 bg-white rounded-[2.5rem] border border-dashed border-slate-200 mt-4"
            >
              <div className="inline-flex items-center justify-center p-4 bg-slate-50 rounded-2xl mb-4">
                <Search size={32} className="text-slate-300" strokeWidth={2.5} />
              </div>
              <h3 className="text-lg sm:text-xl font-black text-slate-700 tracking-tight">No Schools Found</h3>
              <p className="text-slate-400 mt-1 text-sm font-medium">നിങ്ങൾ തിരഞ്ഞ വിവരങ്ങൾ കണ്ടെത്താനായില്ല.</p>
            </motion.div>
          )}

        </div>
      </div>
    </>
  );
}